export default __webpack_public_path__ + "static/media/tokuten_icon_black.c97e3c92.svg";